import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { PedidoService } from '../../services/pedido.service';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import * as QRCode from 'qrcode';

@Component({
  selector: 'app-pagoexitoso',
  templateUrl: './pagoexitoso.component.html',
  styleUrls: ['./pagoexitoso.component.css']
})
export class PagoexitosoComponent implements OnInit {
  cargoid: string;
  pedido: any = null;
  detallePedido: any[] = [];
  qrDataUrl: string = '';
  mostrarBotonTicket = false;
  generandoPDF = false;
  procesando = true;

  @ViewChild('ticketPDF') ticketPDF: ElementRef;

  constructor(private pedidoService: PedidoService, private router: Router) {
    this.cargoid = sessionStorage.getItem('cargoId');
  }

  ngOnInit(): void {
    this.pagoexitoso(this.cargoid);
  }

  pagoexitoso(cargoid: string) {
    this.procesando = true;

    this.pedidoService.pagoExitoso(cargoid).subscribe((resp: any) => {
      this.procesando = false;
      sessionStorage.removeItem('cargoId');
      this.cargarDatosTicket(cargoid);
    }, (err) => {
      this.procesando = false;
      sessionStorage.removeItem('cargoId');
      switch (err.status) {
        case 0:
          Swal.fire({ icon: 'warning', text: 'No hay conexión con el servidor', confirmButtonText: 'Aceptar', confirmButtonColor: '#d01d17' });
          break;
        case 403:
          Swal.fire({ icon: 'warning', text: 'No se registró su pago correctamente, verifique con la sucursal correspondiente', confirmButtonText: 'Aceptar', confirmButtonColor: '#d01d17' });
          break;
        case 409:
          Swal.fire({ icon: 'error', text: 'Error ' + err.status + ' para la actualización del pedido en el servidor', confirmButtonText: 'Aceptar', confirmButtonColor: '#d01d17' });
          break;
        case 500:
          Swal.fire({ icon: 'error', text: 'Error ' + err.status + ' para la actualización del pedido en el servidor', confirmButtonText: 'Aceptar', confirmButtonColor: '#d01d17' });
          break;
        default:
          Swal.fire({ icon: 'error', text: 'Error ' + err.status, confirmButtonText: 'Aceptar', confirmButtonColor: '#d01d17' });
          break;
      }
    });
  }

  cargarDatosTicket(cargoid: string) {
    if (!cargoid) { return; }
    this.pedidoService.getTicketPedido(cargoid).subscribe(async (resp: any) => {
      this.pedido = resp;
      if (resp?.numordenqr) {
        this.qrDataUrl = await QRCode.toDataURL(resp.numordenqr, { width: 240, margin: 1 });
      }
      this.detallePedido = Array.isArray(resp?.articulos) ? resp.articulos : [];
    // this.mostrarBotonTicket = true;
      this.mostrarBotonTicket = false;
      
    }, () => {
      // falla silenciosamente — el botón simplemente no aparece
    });
  }

  async descargarTicket() {
    if (!this.ticketPDF) { return; }
    this.generandoPDF = true;
    try {
      const element = this.ticketPDF.nativeElement;
      const canvas = await html2canvas(element, { scale: 2, useCORS: true, backgroundColor: '#ffffff' });
      const imgData = canvas.toDataURL('image/png');
      // Usar dimensiones personalizadas que se adaptan al alto real del ticket
      const pdfWidthMm  = 100;  // ancho de ticket (mm)
      const pdfHeightMm = (canvas.height * pdfWidthMm) / canvas.width;
      const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: [pdfWidthMm, pdfHeightMm] });
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidthMm, pdfHeightMm);
      pdf.save('ticket-' + (this.pedido?.no_orden || 'pedido') + '.pdf');
    } finally {
      this.generandoPDF = false;
    }
  }
}
